export const POP_UP_ACTION = [
    'EDIT_VEHICLE',
    'POP_UP_PAIR',
    'POP_UP_UNPAIR'
]